var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketsDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2308 9.58317V12.9165C19.2308 15.8332 17.5598 17.0832 15.0533 17.0832H6.69827C4.19176 17.0832 2.52075 15.8332 2.52075 12.9165V7.08317C2.52075 4.1665 4.19176 2.9165 6.69827 2.9165H10.8758",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69849 7.5L9.31362 9.58333C10.1742 10.2667 11.5862 10.2667 12.4468 9.58333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1255 2.3502L17.3594 2.82519C17.4764 3.05852 17.7688 3.27519 18.0278 3.32519L18.3453 3.37519C19.2978 3.53353 19.5234 4.23353 18.8383 4.92519L18.5458 5.21685C18.3537 5.41685 18.2451 5.80019 18.3036 6.06685L18.3453 6.24186C18.6043 7.39186 17.9944 7.83352 16.9918 7.23352L16.7746 7.10852C16.5156 6.95852 16.0978 6.95852 15.8388 7.10852L15.6216 7.23352C14.6106 7.84185 14.0007 7.39186 14.2681 6.24186L14.3098 6.06685C14.3683 5.80019 14.2597 5.41685 14.0675 5.21685L13.7751 4.92519C13.09 4.23353 13.3156 3.53353 14.2681 3.37519L14.5856 3.32519C14.8362 3.28353 15.137 3.05852 15.2539 2.82519L15.4879 2.3502C15.9391 1.44186 16.6743 1.44186 17.1255 2.3502Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsDone);
export default __webpack_public_path__ + "static/media/tickets-done.a7d65bacab61ef120775fdfd50c4b7ac.svg";
export { ForwardRef as ReactComponent };